module.exports = __webpack_public_path__ + "img/location-pin-multi.4784bc77.svg";